<template>
	<div class="login">
		<v-layout row wrap justify-center class="align-items-center login-body-container">
			<div class="login-body">
				<div class="form-header">
					<img class="app-logo" src="/static/img/logo-clerkinn-use.png" alt="logo-clerkinn">
				</div>
				<v-form class="form-body" v-model="valid" v-on:submit.prevent="login">
					<v-text-field
						:label="'Correo electrónico'"
						single-line
						v-model="model.email"
						:rules="emailRules"
						prepend-icon="mail_outline"
						:append-icon="validateEmail(model.email) ? 'check' : ''"
						:append-icon-cb="() => (model.email = !model.email)"
						required
					></v-text-field>
					<v-text-field
						:label="'Contraseña'"
						single-line
						v-model="model.password"
						:rules="passwordRules"
						prepend-icon="vpn_key"
						:append-icon="model.password ? 'check' : ''"
						:append-icon-cb="() => (model.password = !model.password)"
						:type="'password'"
						required
					></v-text-field>
					<v-layout row wrap justify-flex-end align-items-center class="remember-data">
						<v-flex xs11 text-xs-right class="label-check">Recordar mis datos</v-flex>
						<v-flex xs1>
							<v-checkbox
								color="success"
								:append-icon="rememberLogin ? 'check_circle' : 'radio_button_unchecked'"
								:append-icon-cb="() => (rememberLogin = !rememberLogin)"
								hide-details
								v-model="rememberLogin"
							></v-checkbox>
						</v-flex>
					</v-layout>
					<v-layout row wrap justify-center mt-4>
						<v-btn
							type="submit"
							class="button-login"
							:disabled="loading"
							:loading="loading">
							Ingresar
						</v-btn>
					</v-layout>
				</v-form>
			</div>
		</v-layout>
		<v-divider></v-divider>
		<v-layout row wrap class="align-items-center login-footer">
			<v-flex xs6 text-xs-left>
				<ul>
					<li>
						<router-link to="/">Privacidad</router-link>
					</li>
					<li>
						<router-link to="/">Términos y condiciones</router-link>
					</li>
				</ul>
			</v-flex>
			<v-flex xs6 pr-3>
				<v-select
					v-bind:items="languages"
					v-model="currentLanguage"
					:box="true"
					hide-details>
				</v-select>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
	import mixin from '@/shared/mixins';

	const initialLanguages = [
		{ value: 'ES', text: 'Español' },
		{ value: 'EN', text: 'English' },
		{ value: 'ZH-S', text: '简体中文' },
		{ value: 'ZH-T', text: '繁体中文' },
	];

	function login() {
		this.authenticate();
	}

	async function authenticate() {
		this.loading = true;
		const loginUrl = process.env.ACL_URL;
		try {
			const { data: user } = await this.$http.post(`${loginUrl}/authenticate`, this.model);
			this.getEmployeeData(user);
		} catch (err) {
			this.showNotification('Correo o contraseña incorrectas', 'error');
			this.loading = false;
		}
	}
	
	async function getEmployeeData(user) {
		const dashboardHref = { name: 'cms-calendar' };
		try {
			const { data: employee } = await this.$http.get(`${process.env.PMS_URL}/employee-code`, {
				headers: {
					authorization: `Bearer ${user.token}`,
				},
			});
			const userData = JSON.stringify(employee.data);
			localStorage.setItem(process.env.STORAGE_USER_KEY, userData);
			localStorage.setItem(`${process.env.STORAGE_USER_KEY}::token`, user.token);
			this.$router.push(dashboardHref);
		} finally {
			this.loading = false;
		}
	}

	function validateEmail(email) {
		const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(email);
	}

	export default {
		data() {
			return {
				currentLanguage: { value: 'ES', text: 'Español' },
				emailRules: [
					email => !!email || 'Este campo es requerido',
					email => this.validateEmail(email) || 'Debe ingresar un correo válido',
				],
				languages: initialLanguages,
				loading: false,
				model: {
					codeApp: process.env.APP_CODE,
					email: null,
					password: null,
				},
				passwordRules: [
					password => !!password || 'Este campo es requerido',
				],
				rememberLogin: false,
				valid: false,
			};
		},
		methods: {
			authenticate,
			getEmployeeData,
			login,
			validateEmail,
		},
		mixins: mixin,
		name: 'login',
	};
</script>

<style lang="scss" scoped>
	.login {
		background-color: map-get($colors, default-dark);
		min-height: 100vh;

		&-body-container {
			min-height: calc(100vh - 71px);

			@media (min-width: 404px) {
				min-height: calc(100vh - 49px);
			}

			@media (min-width: 608px) {
				min-height: calc(100vh - 45px);
			}
		}

		&-body {
			box-shadow: 0px 15px 32px 0 map-get($colors, box-shadow-login);
			max-width: 320px;
			min-height: 411px;
			width: 90%;

			@media (min-width: 500px) {
				width: 100%;
			}
		}

		.form {
			&-header {
				background-color: map-get($colors, default-skyblue);
				display: flex;
				height: 103.9px;
				justify-content: center;
			}

			&-body {
				background: white;
				height: 308px;
				padding: 39px 23.2px;

				a,
				a:hover,
				a:focus,
				a:active {
					color: map-get($colors, text-login);
					font-size: map-get($sizes, thirdteen);
					margin-top: 19.8px;
				}
			}
		}

		&-footer {
			font-family: map-get($fonts, regular);
			font-size: map-get($sizes, fifteen);
			padding: 2.5px 0px;

			ul {
				list-style: none;
				padding-left: 20px;

				li {
					display: inline-flex;
					margin-right: 31px;

					a,
					a:hover,
					a:focus,
					a:active {
						color: white;
					}
				}
			}

			.input-group {
				box-shadow: none;
				color: white;
				float: right;
				max-width: 98px;
			}
		}
	}

	.label-check {
		font-size: map-get($sizes, twelve);
	}

	.button-login {
		background-color: map-get($colors, button-login) !important;
		box-shadow: none;
		height: 48px;
		max-width: 218.4px;
	}

	.divider {
		background-color: rgba(255, 255, 255, .09);
	}

	.app-logo {
		object-fit: contain;
	}
</style>



// WEBPACK FOOTER //
// Login.vue?640a3dbc